// Storage keys for localStorage
const local_storage_token_location = "ext-at";
const lang = "prefered-lang";
const projectKey = "nb-defult-project";

/**
 * Sets the user's preferred language in localStorage
 * @param {string} locale - The language code (e.g., 'sv-SE', 'en-US')
 */
export function setPreferedLanguage(locale) {
  localStorage.setItem(lang, locale);
}

/**
 * Gets the user's preferred language based on:
 * 1. Current project's available languages
 * 2. Previously saved language preference
 * 3. Default language (sv-SE)
 * @returns {string} The language code to use
 */
export function getPreferedLanguage() {
  const defaultLang = "en-US";
  
  // Get the saved project
  let selectedProject = null;
  try {
    selectedProject = JSON.parse(localStorage.getItem(projectKey));
  } catch {
    return defaultLang;
  }

  // Get user's saved language preference using the lang key
  let savedLanguage = localStorage.getItem(lang) || null;
  if(savedLanguage === null) {
    savedLanguage = defaultLang;
  }
 // Check if project exists and has a valid languages array
  if (selectedProject && selectedProject.languages && Array.isArray(selectedProject.languages)) {
    // Use saved language if it's available in project
    if (savedLanguage && selectedProject.languages.includes(savedLanguage)) {
      return savedLanguage;
    }
    
    // If no saved language or saved language not in project, use first available language
    const firstLanguage = selectedProject.languages[0];
    localStorage.setItem(lang, firstLanguage);
    return firstLanguage;
  }

  return defaultLang;
}

/**
 * Saves the project's available languages and updates language preference if needed
 * @param {Object} project - The project object containing languages array
 */
export function setAvalibleLanguages(project) {
  try {
    localStorage.setItem(projectKey, JSON.stringify(project));
    
    // Check if current language is valid for the new project
    const currentLang = localStorage.getItem(lang);
    if (currentLang && (!project.languages || !project.languages.includes(currentLang))) {
      // Reset to english or first available language if current is invalid
      const newLang = project.languages && project.languages.includes("en-US") 
        ? "en-US" 
        : (project.languages && project.languages[0]) || "en-US";
      setPreferedLanguage(newLang);
    }
  } catch (error) {
    console.error("Error setting available languages:", error);
  }
}

/**
 * Saves the complete project object to localStorage
 * @param {Object} project - The complete project object
 */
export function setProject(project) {
  try {
    localStorage.setItem(projectKey, JSON.stringify(project));
  } catch (error) {
    console.error("Error setting project:", error);
  }
}

/**
 * Retrieves the complete project object from localStorage
 * @returns {Object|null} The project object or null if not found/invalid
 */
export function getProject() {
  try {
    const project = localStorage.getItem(projectKey);
    if (project === null) {
      return null;
    } else {
      return JSON.parse(project);
    }
  } catch (error) {
    console.error("Error getting project:", error);
    return null;
  }
}

/**
 * Gets available language options for the current project
 * @returns {string[]} Array of language codes
 */
export function getLanguageOptions() {
  try {
    const selectedProject = JSON.parse(localStorage.getItem(projectKey));
    if (selectedProject && selectedProject.languages && Array.isArray(selectedProject.languages)) {
      return selectedProject.languages;
    }
  } catch (error) {
    console.error("Error getting language options:", error);
  }
  return ["en-US", "sv-SE"]; // Default language options
}

/**
 * Checks if user is authenticated by looking for token
 * @returns {boolean} True if token exists
 */
export function tokenExist() {
  return localStorage.getItem(local_storage_token_location) !== null;
}
